var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-to-top',{attrs:{"visibleoffset":"20","bottom":"30px","right":"10px"}},[_c('button',{staticClass:"btn btn-primary btn-to-top",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }